<app-import-nav />

<h5 class="mt-3">ARS Consult Note Import History</h5>

<div class="container-fluid p-2 border rounded bg-light">
  <!-- text filters apply on search so a patient name search is audited once, not per keystroke -->
  <form novalidate (ngSubmit)="onFilterChange()">
    <div class="row g-2 align-items-end">
      <div class="col-3">
        <label for="clientIds" class="my-0">Client</label>
        <app-client-select
          name="clientIds"
          placeholder="Filter by Client"
          minWidth="none"
          [multiple]="true"
          [autoLoad]="true"
          [(selectedIds)]="filters.selectedClientIds"
          (changed)="onFilterChange()" />
      </div>
      <div class="col-2">
        <label for="patientFirstName" class="my-0">Patient First</label>
        <input
          id="patientFirstName"
          name="patientFirstName"
          class="form-control"
          placeholder="Starts with"
          [(ngModel)]="filters.patientFirstName" />
      </div>
      <div class="col-2">
        <label for="patientLastName" class="my-0">Patient Last</label>
        <input
          id="patientLastName"
          name="patientLastName"
          class="form-control"
          [(ngModel)]="filters.patientLastName" />
      </div>
      <div class="col-2">
        <label for="prescriberNpi" class="my-0">Prescriber NPI</label>
        <input
          id="prescriberNpi"
          name="prescriberNpi"
          class="form-control"
          [(ngModel)]="filters.prescriberNpi" />
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-primary">Search</button>
      </div>
      <div class="col-auto ms-auto">
        <div class="form-check mb-2">
          <input class="form-check-input"
            type="checkbox"
            id="requiresIntervention"
            name="requiresIntervention"
            [(ngModel)]="filters.requiresIntervention"
            (change)="onFilterChange()" />
          <label class="form-check-label" for="requiresIntervention">Requires Intervention</label>
        </div>
      </div>
    </div>
  </form>
</div>

@if (!loading) {
  <div>
    @if (arsConsultNoteImports.length > 0) {
      <section class="mt-3">
        <div class="col-12">
          <app-pagination-header [paging]="paging" [label]="'imports'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>CLIENT</th>
              <th>DOCUMENT</th>
              <th>PATIENT</th>
              <th>PRESCRIBER</th>
              <th class="text-end">WIP PATIENT CAPTURES</th>
              <th class="text-end">WIP PATIENT-PRESCRIBER CAPTURES</th>
              <th>STATUS</th>
              <th class="text-nowrap text-end">DATE IMPORTED</th>
              <th>EXCEPTION</th>
            </tr>
          </thead>
          <tbody>
            @for (arsConsultNoteImport of arsConsultNoteImports; track arsConsultNoteImport.id) {
              <tr [class.table-danger]="arsConsultNoteImport.requiresIntervention">
                <td>{{ arsConsultNoteImport.client?.name || '--' }}</td>
                <td>
                  <a class="phi" routerLink="/capture-admin/tools/import-ars-consult-notes/history/{{ arsConsultNoteImport.id }}">
                    {{ arsConsultNoteImport.documentName }}
                  </a>
                  <div><small class="text-muted">{{ arsConsultNoteImport.uuid }}</small></div>
                  @if (arsConsultNoteImport.patientAttachmentId) {
                    <div>
                      <small>
                        Consult Note:
                        <a
                          target="_blank"
                          routerLink="/capture-admin/consult-notes/{{ arsConsultNoteImport.patientAttachmentId }}">
                          {{ arsConsultNoteImport.patientAttachmentId }}
                        </a>
                      </small>
                    </div>
                  }
                </td>
                <td>
                  <app-patient-name
                    [patient]="arsConsultNoteImport.patient"
                    [canViewPatient]="true"
                    [showAlternateNames]="false" />
                </td>
                <td><app-prescriber-name [provider]="arsConsultNoteImport.provider" /></td>
                <td class="text-end">{{ arsConsultNoteImport.wipPatientCaptureCount ?? '--' }}</td>
                <td class="text-end">{{ arsConsultNoteImport.wipPatientPrescriberCaptureCount ?? '--' }}</td>
                <td class="text-nowrap">{{ arsConsultNoteImport.status | replace: '_' : ' ' | titlecase }}</td>
                <td class="text-nowrap text-end">{{ arsConsultNoteImport.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
                <td class="text-break">{{ arsConsultNoteImport.exception }}</td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section class="mt-3"><p>There are no imports.</p></section>
    }
  </div>
} @else {
  <section class="mt-3"><mat-spinner diameter="30" /></section>
}
